import type { WashPackage } from '@/types'

// Reads the first number out of a price label such as "£12" or "from £1,200" so packages can be compared.
const priceValue = (price: string | null): number => {
    if (!price) return Number.POSITIVE_INFINITY

    const match = price.replace(/,/g, '').match(/\d+(?:\.\d+)?/)

    return match ? Number(match[0]) : Number.POSITIVE_INFINITY
}

export const getStartingPackage = (packages: Array<WashPackage>): WashPackage | null => {
    const priced = packages.filter(item => item.price)

    if (priced.length === 0) return null

    return priced.reduce((lowest, item) => priceValue(item.price) < priceValue(lowest.price) ? item : lowest)
}
